import { mixins} from 'vue-chartjs'

export default {
    mixins: [mixins.reactiveProp],

    props: ['options'],

    mounted () {
        // Overwriting base render method with actual data.
        this.renderChart(this.chartData, this.options)
    }
}


// WEBPACK FOOTER //
// ./src/components/stats/charts/common/reactiveChart.mixin.js